import { render, staticRenderFns } from "./edit-controlCampanaDuplicado.vue?vue&type=template&id=5f934fd0"
import script from "./edit-controlCampanaDuplicado.vue?vue&type=script&lang=ts"
export * from "./edit-controlCampanaDuplicado.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports